import {useMutation, useQueryClient} from '@tanstack/react-query';
import axios, {AxiosError} from 'axios';
import {CreateInvitationRequest, CreateInvitationResponse} from '../Types/invitationTypes';
import {INVITATIONS_QUERY_KEY} from '../Shared/invitationQueryKeys';

const useCreateInvitation = () => {
  const queryClient = useQueryClient();

  return useMutation<CreateInvitationResponse, AxiosError, CreateInvitationRequest>({
    mutationFn: async (data) => axios.post('/api/invitations', data).then((res) => res.data),
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: INVITATIONS_QUERY_KEY});
    },
  });
};

export default useCreateInvitation;
